import { GenericEventEmitter } from 'Utility/GameEvent/GenericEventEmitter';
import { LocalNotificationTracking } from 'Utility/GameEvent/Events/LocalNotificationTracking';
import { ProcessPersistedTrackingData } from 'Utility/GameEvent/EventHandlers/ProcessPersistedTrackingData';

export type EventType = LocalNotificationTracking | ProcessPersistedTrackingData;

export class GameEvents extends GenericEventEmitter<EventType> {}
